import { Card, CardBody, Col } from "reactstrap";
import { BlockQuotes, P } from "../../../../AbstractElements";
import { BlockquotesTitle } from "../../../../Constants/Constants";
import { BlockQuotesData, BlockQuotesSubTitle } from "../../../../Data/UiKits/Typography";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const BlockQuotesCard = () => {
  return (
    <Col sm="12">
      <Card className="overflow-hidden">
        <CommonCardHeader title={BlockquotesTitle} span={BlockQuotesSubTitle} />
        <CardBody>
          {BlockQuotesData &&
            BlockQuotesData.map((item, index) => (
              <div key={index} className={`figure d-block dark-blockquote ${item.class ? item.class : ""}`}>
                <BlockQuotes className={`blockquote light-card`}>
                  <P className="mb-0 txt-dark">{item.text}</P>
                  <span className="blockquote-footer pt-3">{item.footer}</span>
                </BlockQuotes>
              </div>
            ))}
        </CardBody>
      </Card>
    </Col>
  );
};
export default BlockQuotesCard